import { observable } from 'mobx';
import type { OrderItemResponseArgs } from './order_item2';
import OrderItem, { convertOrderItemResponseToArgs } from './order_item2';

export type OrderResponseArgs = {
  id: number;
  order_items?: OrderItemResponseArgs[];
};

export type OrderArgs = {
  id: number;
  showFee: boolean;
  orderItems: OrderItem[];
};

export const convertOrderResponseToArgs = (response: OrderResponseArgs, showFee: boolean) => {
  const args: OrderArgs = {
    id: response.id,
    showFee,
    orderItems:
      response.order_items?.map(orderItem => new OrderItem(convertOrderItemResponseToArgs(orderItem, showFee))) ||
      []
  };
  return args;
};

export default class Order {
  @observable
  id: number;

  @observable
  showFee: boolean;

  @observable
  orderItems: OrderItem[];

  constructor(args: OrderArgs) {
    this.id = args.id;
    this.showFee = args.showFee;
    this.orderItems = args.orderItems;
  }

  get totalPrice() {
    return this.orderItems.reduce((acc, item) => acc + item.price.price, 0);
  }
}
